import ProcessComp from "./processComp";
import ComparisonCard from "./comparisonCard";
import Slider from "./slider";
import CmtyCard from "./cmtyCard";
export {
  ProcessComp,
  Slider,
  ComparisonCard,
  CmtyCard,
}